import { SongDetails } from "./Songs";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Moods({user}) {
    const API_BASE = "https://moodifyfinal-production.up.railway.app";
    const [moods, setMoods] = useState([]);
    const [showAddForm, setShowAddForm] = useState(false);
    const [newMood, setNewMood] = useState({ Name: "", Description: "" });

    const [page, setPage] = useState(1);
    const limit = 5; //lets call 5 mood per page tho rn i dont think i have 5 moods but why not
    const [total, setTotal] = useState(0);

    const navigate = useNavigate();

    const { t } = useTranslation();

    useEffect(() => {
        refreshMoods();
    }, [page]);

    function refreshMoods() {
        fetch(`${API_BASE}/moods?page=${page}&limit=${limit}`)
            .then(res => res.json())
            .then(result => {
                setMoods(result.data);
                setTotal(result.total);
            })
            .catch(err => console.error(err));
    }

    function addMood() {
        if (!user) {alert(t("You must log in to add a mood"));return;}

        fetch(`${API_BASE}/moods/add`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                Name: newMood.Name,
                Description: newMood.Description,
                Created_By: user.ID
            })

        })
            .then(res => {
                if (!res.ok) {
                    return res.json().then(err => {
                        throw new Error(err.error);
                    });
                }
                return res.json();
            })
            .then(() => {
                setNewMood({ Name: "", Description: "" });
                setShowAddForm(false);
                refreshMoods();
            })
            .catch(err => alert(err.message));
    }

    function cancelAdd() {
        setShowAddForm(false);
        setNewMood({ Name: "", Description: "" });
    }

    return (
        <section id="MOODS">

            {showAddForm ? (
                <>
                    <h2 id="Title">Add Mood</h2>

                    <input
                        placeholder={t("Name")}
                        value={newMood.Name}
                        onChange={e =>
                            setNewMood({ ...newMood, Name: e.target.value })
                        }
                    />

                    <textarea
                        placeholder={t("Description")}
                        value={newMood.Description}
                        onChange={e =>
                            setNewMood({ ...newMood, Description: e.target.value })
                        }
                    />

                    <br />

                    <button onClick={addMood}>{t("Add")}</button>
                    <button onClick={cancelAdd}>{t("Cancel")}</button>
                    <hr />
                </>
            ) : (
                <>
                    <h2 id="Title">{t("Moods")}</h2>

                    <table>
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th>{t("Name")}</th>
                            <th>{t("Description")}</th>
                            <th>{t("Created By")}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {moods.map(mood => (
                            <tr key={mood.ID}>
                                <td>{mood.ID}</td>
                                <td>
                                    <button
                                        onClick={() => navigate(`/moods/${mood.ID}`)}
                                    >
                                        {mood.Name}
                                    </button>
                                </td>
                                <td>{mood.Description}</td>
                                <td>{mood.Created_By}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>

                    {/*margin =>spcae outside     padding=>space inside*/}
                    <div style={{ marginTop: "10px" }}>

                        <button disabled={page === 1} onClick={() => setPage(page - 1)}>
                            {t("Page")}</button>

                        <span style={{ margin: "0 10px" }}>Page {page} of {Math.ceil(total / limit)}</span>

                        <button disabled={page >= Math.ceil(total / limit)} onClick={() => setPage(page + 1)}>
                            {t("Next")}</button>
                    </div>

                    <hr />
                </>
            )}
        </section>
    );
}

function MoodDetails({user}) {
    const API_BASE = "https://moodifyfinal-production.up.railway.app";

    const { id } = useParams();
    const navigate = useNavigate();
    const moodId = Number(id);

    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    const [selectedSongId, setSelectedSongId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [editMood, setEditMood] = useState(null);
    const [availableSongs, setAvailableSongs] = useState([]);
    const [selectedSongToAdd, setSelectedSongToAdd] = useState("");

    const { t } = useTranslation();

    useEffect(() => {
        setLoading(true);

        fetch(`${API_BASE}/moods/${moodId}`)
            .then(res => res.json())
            .then(data => {
                setDetails(data);
                setLoading(false);
            });

        fetch(`${API_BASE}/moods/${moodId}/availablesongs`)
            .then(res => res.json())
            .then(data => setAvailableSongs(data));
    }, [moodId]);

    if (!details) return <p>{t("Mood not found")}</p>;

    if (selectedSongId) {
        return (
            <SongDetails
                songId={selectedSongId}
                onBack={() => setSelectedSongId(null)}
            />
        );
    }

    function startEdit() {
        setEditMood({ ...details.mood });
        setIsEditing(true);
    }

    function cancelEdit() {
        setIsEditing(false);
        setEditMood(null);
    }

    function saveEdit() {
        fetch(`${API_BASE}/moods/${editMood.ID}/edit`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(editMood)
        })
            .then(res => {
                if (!res.ok) throw new Error("Update failed");
                return res.json();
            })
            .then(() => {
                setDetails({...details,mood:editMood});
                setIsEditing(false);
            })
            .catch(err => alert(err.message));
    }

    function deleteMood() {
        if (!window.confirm("Are you sure you want to delete this mood??")) return;

        fetch(`${API_BASE}/moods/${moodId}/delete`, {
            method: "DELETE"
        })
            .then(res => {
                if (!res.ok) throw new Error("upsi,delete failed");
                navigate("/moods");
            })
            .catch(err => alert(err.message));
    }

    function addSongToMood() {
        if (!selectedSongToAdd) {
            alert("Pick a song");
            return;
        }

        fetch(`${API_BASE}/moods/${moodId}/songs`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ Song_ID: Number(selectedSongToAdd) })
        })
            .then(res => {
                if (!res.ok) {
                    return res.json().then(err => {
                        throw new Error(err.error);
                    });
                }
                return res.json();
            })
            .then(() =>
                fetch(`${API_BASE}/moods/${moodId}`)
                    .then(res => res.json())
                    .then(data => setDetails(data))
            )
            .then(() =>
                fetch(`${API_BASE}/moods/${moodId}/availablesongs`)
                    .then(res => res.json())
                    .then(data => {
                        setAvailableSongs(data);
                        setSelectedSongToAdd("");
                    })
            )
            .catch(err => alert(err.message));
    }

    function removeSongFromMood(songID) {
        if (!window.confirm("Are you sure to remove this song??")) return;

        fetch(`${API_BASE}/moods/${moodId}/songs/${songID}/delete`, {
            method: "DELETE"
        })
            .then(res => {
                if (!res.ok) {
                    return res.json().then(err => {
                        throw new Error(err.error);
                    });
                }
                return res.json();
            })
            .then(() =>
                fetch(`${API_BASE}/moods/${moodId}`)
                    .then(res => res.json())
                    .then(data => setDetails(data))
            )
            .then(() =>
                fetch(`${API_BASE}/moods/${moodId}/availablesongs`)
                    .then(res => res.json())
                    .then(data => setAvailableSongs(data))
            )
            .catch(err => alert(err.message));
    }

    console.log("USER:", user);
    console.log("CREATED BY:", details.mood.Created_By);


    return (
        <>
            <h2 id="Title">{t("Mood Details")}</h2>

            {!isEditing ? (
                <>
                    <p><strong>ID:</strong> {details.mood.ID}</p>
                    <p><strong>{t("Name")}:</strong> {details.mood.Name}</p>
                    <p><strong>{t("Description")}:</strong> {details.mood.Description}</p>
                    <p><strong>{t("Created By")}:</strong> {details.mood.Created_By}</p>

                    <h3>{t("Songs in this mood")}</h3>

                    {details.songs.length === 0 && <p>{t("No songs added")}</p>}

                    <ul>
                        {details.songs.map(song => (
                            <li key={song.ID}>
                                <button onClick={() => setSelectedSongId(song.ID)}>
                                    {song.Name}
                                </button>
                                {" "}({song.Artist})
                                {" "}{user && details.mood.Created_By === user.Name &&
                                (<button onClick={() => removeSongFromMood(song.ID)}>
                                    {t("Remove")}
                                </button>)}
                            </li>
                        ))}
                    </ul>

                    {user &&(
                        <>
                            <h4>{t("Add song")}</h4>

                            {availableSongs.length === 0 ? (
                                <p>{t("No available songs")}</p>
                            ) : (
                                <>
                                    <select
                                        value={selectedSongToAdd}
                                        onChange={e => setSelectedSongToAdd(e.target.value)}
                                    >
                                        <option value="">-- {t("Select")} --</option>
                                        {availableSongs.map(song => (
                                            <option key={song.ID} value={song.ID}>
                                                {song.Name} – {song.Artist}
                                            </option>
                                        ))}
                                    </select>
                                    <button onClick={addSongToMood}>{t("Add")}</button>
                                </>
                            )}
                        </>
                    )}

                    {console.log(user)}
                    <br />
                    <button onClick={() => navigate("/moods")}>{t("Back")}</button>
                    {user && Number(user.God_Privilege) === 1 && (
                        <button onClick={deleteMood}>{t("Delete")}</button>
                    )}


                    {user && details.mood.Created_By === user.Name && (
                        <button onClick={startEdit}>{t("Edit")}</button>
                    )}

                </>
            ) : (
                <>
                    <input
                        value={editMood.Name}
                        onChange={e =>
                            setEditMood({ ...editMood, Name: e.target.value })
                        }
                    />
                    <textarea
                        value={editMood.Description}
                        onChange={e =>
                            setEditMood({ ...editMood, Description: e.target.value })
                        }
                    />
                    <button onClick={saveEdit}>{t("Save")}</button>
                    <button onClick={cancelEdit}>{t("Cancel")}</button>
                </>
            )}
        </>
    );
}

export default Moods;
export { MoodDetails };